<script setup lang="ts">
import IconLoading from '@/components/icons/IconLoading.vue'

const props = withDefaults(
  defineProps<{
    color?: string
  }>(),
  {
    color: '#5900CB'
  }
)
</script>
<template>
  <div class="flex flex-col items-center gap-[16px]">
    <div class="font-[700] text-[#000000DE]"><slot></slot></div>
    <IconLoading :color="props.color"></IconLoading>
  </div>
</template>
